import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import { SiteRutas } from "../../request/RutasConfig";
import { Obtener_CallCenter_Empresa_Request, Get_Description_Report } from "../../request/ParametroRequest";
import { Obtener_Estatus_Request } from "../../request/CallCenterMonitorRequest";
import { SucursalZona_Obtener_Sucursales_CallCenter } from "../../request/MantenimientosRequest";
import { SetParametrosReporte } from "../../request/ReporteRequest";
import { Notificacion } from "../../components/Util/Notificacion/Notificacion";
import ReporteIntfz from "./ReporteIntfz.jsx";

class reporte extends PureComponent {
    _isMounted = false;

    state = {
        Datos: {
            CC_id: {
                value: 0,
                attributes: {
                    focus: false,
                    hidden: "none",
                    label: "Call Center:",
                    id: 49
                }
            },
            FechaInicio: {
                value: new Date("1900/01/01"),
                attributes: {
                    focus: false,
                    hidden: "none",
                    label: "Fecha Inicio:",
                    id: 4
                }
            },
            FechaFinal: {
                value: new Date("1900/01/01"),
                attributes: {
                    focus: false,
                    hidden: "none",
                    label: "Fecha Final:",
                    id: 4
                }
            },
            IncluirResumen: {
                value: false,
                attributes: {
                    focus: false,
                    hidden: "none",
                    label: "Incluir Resumen",
                    id: 0
                }
            },
            Sucursal: {
                value: 0,
                attributes: {
                    focus: false,
                    hidden: "none",
                    label: "Sucursales:",
                    id: 5
                }
            },
            Estatus: {
                value: 0,
                attributes: {
                    focus: false,
                    hidden: "none",
                    label: "Estado:",
                    id: 6
                }
            }
        },
        titulo: '',
        descripcion: '',
        ReportId: 0,
        listaCallCenter: [],
        selectedCallCenter: null,
        listaEstatus: [],
        selectedEstatus: null,
        listaSucursales: [],
        selectedSucursales: [],
    };

    componentDidMount = async () => {
        this._isMounted = true;

        const reporte_id = this.props.match.params.ReportId;
        const filtros = this.props.match.params.Sec;

        this.Init_Reporte(reporte_id, filtros);
        this.Obtener_CallCenters_Por_Empresa();
        this.Obtener_Estatus();
    };

    componentDidUpdate = async (prevProps) => {
        if (prevProps.match.params.ReportId !== this.props.match.params.ReportId) {

            const reporte_id = this.props.match.params.ReportId;
            const filtros = this.props.match.params.Sec;

            this.Init_Reporte(reporte_id, filtros);

            const listaCallCenter = this.state.listaCallCenter;
            const selectedCallCenter = listaCallCenter.length > 0 ? listaCallCenter[0] : null;
            this._isMounted && this.setState({ selectedCallCenter });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    Init_Reporte = (pReporte_Id, pSec) => {

        let Datos = this.habilitarFiltros(pSec);

        let FechaInicio = moment(moment().subtract(7, "days").format("YYYY-MM-DD")).toDate();
        let FechaFinal = moment(moment().format("YYYY-MM-DD")).toDate();
        Datos.FechaInicio.value = FechaInicio;
        Datos.FechaFinal.value = FechaFinal;
        Datos.IncluirResumen.value = false;

        this.Obtener_Datos_Reporte(pReporte_Id);

        this._isMounted && this.setState({ Datos });
    };

    Obtener_Datos_Reporte = async (pReporte_Id) => {

        const response = await Get_Description_Report(this.props.token, pReporte_Id);
        if (response.Exitoso) {
            const titulo = response.Datos.ReportTitulo;
            const descripcion = response.Datos.ReportDesc;
            this._isMounted && this.setState({ ReportId: pReporte_Id, titulo, descripcion });

        } else {
            Notificacion.error(response.Mensaje);
        }
    };

    Obtener_CallCenters_Por_Empresa = async () => {

        let response = await Obtener_CallCenter_Empresa_Request(this.props.token, this.props.empresa.Id);
        if (response.Exitoso) {

            let listaCallCenter = [];

            response.Datos.sort((a, b) => {
                if (a.Nombre > b.Nombre) {
                    return 1;
                } else if (a.Nombre < b.Nombre) {
                    return -1;
                }
                return 0;
            }).forEach(item => {
                listaCallCenter.push({ value: item.Id, label: item.Nombre });
            });

            const selectedCallCenter = listaCallCenter.length > 0 ? listaCallCenter[0] : null;
            this._isMounted && this.setState({ listaCallCenter, selectedCallCenter }, () => this.Obtener_Sucursales_Por_CallCenter());
        } else {
            Notificacion.error(response.Mensaje);
        }
    };

    Obtener_Sucursales_Por_CallCenter = async () => {

        const { selectedCallCenter } = this.state;
        let listaSucursales = [{ value: 'TOD', label: 'Todas' }];

        if (selectedCallCenter) {

            const response = await SucursalZona_Obtener_Sucursales_CallCenter(this.props.token, this.props.empresa.Id, selectedCallCenter.value);
            if (response.Exitoso) {
                response.Datos.forEach((item) => {
                    listaSucursales.push({ value: item.Suc_id, label: item.Suc_Nombre });
                });

            } else {
                Notificacion.error(response.Mensaje);
            }
        }

        this._isMounted && this.setState({ listaSucursales });
    };

    Obtener_Estatus = async () => {

        let response = await Obtener_Estatus_Request(this.props.token, this.props.empresa.Id);
        if (response.Exitoso) {

            let listaEstatus = [];
            let selectedEstatus = null;

            response.Datos.forEach(item => {
                listaEstatus.push({ value: item.Estatus_Id, label: item.Estatus_Nombre });
            });

            selectedEstatus = listaEstatus.length > 0 ? listaEstatus[0] : null;
            this._isMounted && this.setState({ listaEstatus, selectedEstatus });
        } else {
            Notificacion.error(response.Mensaje);
        }
    };

    habilitarFiltros = pFiltros => {
        let Datos = { ...this.state.Datos };
        const listFiltro = pFiltros.split("|");
        for (let key in Datos) {
            Datos[key].attributes.hidden = "none";
        }

        for (let key in Datos) {
            listFiltro.forEach(valor => {
                if (parseInt(Datos[key].attributes.id) == parseInt(valor)) {
                    Datos[key].attributes.hidden = "unset";
                }
            });
        }
        return Datos;
    };

    onhandleSelectSucursales = selectedSucursales => {

        const selTodos = selectedSucursales ? selectedSucursales.filter(x => x.value === 'TOD') : [];
        if (selTodos.length > 0) {

            const Sucursales = this.state.listaSucursales.slice(1);
            this.setState({ selectedSucursales: Sucursales });

        } else {
            this.setState({ selectedSucursales });
        }

    };

    onhandleSelectedOption = option => {
        this.setState({ selectedCallCenter: option }, () => this.Obtener_Sucursales_Por_CallCenter());
    };

    onhandleSelectedEstatus = async selectedEstatus => {
        this.setState({ selectedEstatus });
    };

    onChangeDate = (name, date) => {
        let newAttributes = this.state.Datos[name].attributes;

        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: date, attributes: newAttributes },
        });

        this.setState({ Datos });
    };

    handleCheckBox = event => {
        const name = event.target.name;
        const value = event.target.checked;
        let newAttributes = this.state.Datos[name].attributes;

        let Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });

        this.setState({ Datos });
    };

    volverAtras = () => {
        this.props.history.push(SiteRutas.Home);
    };

    validarDatos = () => {
        let { Datos, selectedSucursales } = this.state;

        if (Datos.FechaInicio.attributes.hidden != "none") {
            if (Datos.FechaInicio.value == null) {
                Notificacion.error("Debe seleccionar una Fecha Inicio válida");
                return false;
            }

            if (Datos.FechaFinal.value == null) {
                Notificacion.error("Debe seleccionar una Fecha Final válida");
                return false;
            }

            if (Datos.FechaInicio.value > Datos.FechaFinal.value) {
                Notificacion.error("Fecha Inicio no puede ser mayor a la Fecha Final");
                return false;
            }

            if (Datos.FechaFinal.value < Datos.FechaInicio.value) {
                Notificacion.error(
                    "Fecha Final no puede ser Menor que la Fecha Inicio"
                );
                return false;
            }
        }

        if (Datos.Sucursal.attributes.hidden !== "none") {
            if (selectedSucursales.length === 0) {
                Notificacion.error("Debe seleccionar al menos una Sucursal");
                return false;
            }
        }

        return true;
    };

    onGenerarReporte = async () => {
        let { Datos, titulo, selectedCallCenter, selectedEstatus, selectedSucursales, ReportId } = this.state;
        let Empresa = this.props.empresa.Id;
        let EmpresaNombre = this.props.empresa.Nombre;
        let Resumen = "";
        let i = 1;

        if (this.validarDatos()) {
            let FechaInicio = moment(Datos.FechaInicio.value).format("YYYY/MM/DD");
            let FechaFinal = moment(Datos.FechaFinal.value).format("YYYY/MM/DD");

            if (Datos.IncluirResumen.value) {
                Resumen =
                    "Los parámetros seleccionados para el " + titulo + " son: \n\n";

                Resumen = Resumen + i.toString() + ". - Empresa:\n";
                Resumen = Resumen + "  " + i.toString() + ".1. - " + EmpresaNombre + "\n";

                if (Datos.CC_id.attributes.hidden != "none") {
                    i++;
                    Resumen =
                        Resumen + i.toString() + ".- CallCenter: " + selectedCallCenter.label + " \n";
                }

                if (Datos.Sucursal.attributes.hidden !== "none") {
                    i++;
                    Resumen = Resumen + i.toString() + ".- Estado: " + selectedEstatus.label.trim() + "\n";
                }

                if (Datos.Sucursal.attributes.hidden !== "none") {
                    i++;
                    Resumen = Resumen + i.toString() + ".- Sucursales: " + selectedSucursales.map(suc => suc.label.trim()).join(', ') + "\n";
                }

                if (Datos.FechaInicio.attributes.hidden != "none") {
                    i++;
                    Resumen = Resumen + i.toString() + ".- Fecha Inicial: " + moment(Datos.FechaInicio.value).format("DD/MM/YYYY") + "\n";
                    i++;
                    Resumen = Resumen + i.toString() + ".- Fecha Final: " + moment(Datos.FechaFinal.value).format("DD/MM/YYYY") + "\n";
                }

                Resumen = Resumen + "\n";

            }

            let params = {
                Reporte: ReportId,
                Empresa: Empresa,
                Titulo: titulo,
                NombreEmpresa: EmpresaNombre,
                CC: selectedCallCenter.value,
                FechaInicio: FechaInicio,
                FechaFinal: FechaFinal,
                Estado: selectedEstatus.value,
                Sucursales: selectedSucursales.map(suc => suc.value).join(','),
                IncluirResumen: Datos.IncluirResumen.value,
                Resumen: Resumen,
            };

            try {
                var url = window.location.href;
                var index = url.indexOf("/reporte/");

                url = url.substring(0, index) +
                    `/ReportesSSR/MuestraReporte.aspx?ReporteId=${ReportId}&Empresa=${Empresa}`;

                let data = await SetParametrosReporte(this.props.token, params);
                if (data.length > 0) {
                    Notificacion.error(data);
                } else {
                    const myWindow = window.open();
                    setTimeout(() => {
                        myWindow.location.replace(url);
                    }, 1);
                }
            } catch (err) {
                console.log("cargar reporte", err);
            }
        }
    };

    render() {
        const {
            listaCallCenter,
            selectedCallCenter,
            Datos,
            titulo,
            descripcion,
            listaSucursales,
            listaEstatus,
            selectedSucursales,
            selectedEstatus
        } = this.state;

        return <ReporteIntfz
            listaCallCenter={listaCallCenter}
            selectedCallCenter={selectedCallCenter}
            Datos={Datos}
            titulo={titulo}
            descripcion={descripcion}
            onGenerarReporte={this.onGenerarReporte}
            volverAtras={this.volverAtras}
            handleCheckBox={this.handleCheckBox}
            onChangeDate={this.onChangeDate}
            onhandleSelectedOption={this.onhandleSelectedOption}
            onhandleSelectSucursales={this.onhandleSelectSucursales}
            listaSucursales={listaSucursales}
            listaEstatus={listaEstatus}
            selectedEstatus={selectedEstatus}
            selectedSucursales={selectedSucursales}
            onhandleSelectedEstatus={this.onhandleSelectedEstatus}
        />;
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter,
    };
};

export default connect(mapStateToProps)(withRouter(memo(reporte)));
